import React from "react";
import { Typography } from "@mui/material";
import styles from "./SectionTitle.module.scss";

interface SectionTitleProps {
    title: string;
    subtitle?: string;
    centered?: boolean;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ title, subtitle, centered = true }) => {
    return (
        <div className={`${styles.container} ${centered ? styles.centered : ""}`}>
            <Typography variant="h2" component="h2" className={styles.title}>
                {title}
            </Typography>
            {subtitle && (
                <Typography variant="h6" component="p" className={styles.subtitle}>
                    {subtitle}
                </Typography>
            )}
        </div>
    );
};

export default SectionTitle;
